import DOMPurify from 'dompurify';

const SAFE_COLOR = /^(?:#[0-9a-f]{3,8}|rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)|rgba\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*(?:0|1|0?\.\d+)\s*\)|[a-z]{3,20})$/i;

let hooksReady = false;

function safeStyle(value) {
  const kept = [];
  String(value || '').split(';').forEach((part) => {
    const match = part.trim().match(/^(color|background-color)\s*:\s*(.+)$/i);
    if (!match) return;
    const color = match[2].trim();
    if (/url|expression|javascript|@import|\/\*|\*\//i.test(color)) return;
    if (!SAFE_COLOR.test(color)) return;
    kept.push(`${match[1].toLowerCase()}: ${color}`);
  });
  return kept.join('; ');
}

function ensureHooks() {
  if (hooksReady) return;
  hooksReady = true;

  DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
    if (data.attrName === 'style') {
      const style = safeStyle(data.attrValue);
      if (!style) data.keepAttr = false;
      else data.attrValue = style;
      return;
    }

    if (data.attrName === 'class') {
      const classes = String(data.attrValue || '')
        .split(/\s+/)
        .filter((name) => /^(?:ql-[a-z0-9-]+|article-table)$/i.test(name));
      if (!classes.length) data.keepAttr = false;
      else data.attrValue = classes.join(' ');
    }
  });

  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      const href = (node.getAttribute('href') || '').trim();
      if (!/^(?:https?:|mailto:|\/|#)/i.test(href)) node.removeAttribute('href');
      if (node.getAttribute('target') === '_blank') node.setAttribute('rel', 'noopener noreferrer');
    }
    if (node.tagName === 'IMG') {
      const src = (node.getAttribute('src') || '').trim();
      if (!/^(?:https?:|\/)/i.test(src)) node.parentNode && node.parentNode.removeChild(node);
    }
  });
}

export function sanitizeArticleHtml(html) {
  if (!html) return '';
  ensureHooks();
  return DOMPurify.sanitize(String(html), {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'iframe', 'object', 'embed', 'svg', 'math', 'script'],
    ADD_ATTR: ['target', 'rel'],
    ALLOW_DATA_ATTR: false
  });
}
